import React, { FC } from "react";
import clsx from "clsx";
import HelpIcon from "@mui/icons-material/Help";
import IconMenuButton from "../../Tools/IconMenuButton";
import QuizIcon from "@mui/icons-material/Quiz";
import { downloadErrorFile } from "../../Tools/Tools";
import { smetaModals } from "../../Tools/modalManager";
import DialogInstallScriptsUpdates from "../../Module/Dialogs/DialogInstallScriptsUpdate";
import DialogAboutSite from "../../Module/Dialogs/DialogAboutSite";
import { useAtomValue } from "jotai";
import { appConfig, currentTheme, helpContextAtom, smetaStore } from "../../../../atoms";
import DialogHelpContext from "../../Module/Dialogs/DialogHelpContext";
import { CheckModalBackGrounds } from "../../../TokenProcessing/TokenProcessing";
import { getOptionsForUser } from "../../../Url";
import SupportRequest from "./SupportRequest/SupportRequest";

const openUpdtInstall = () => {
  smetaModals.open(<DialogInstallScriptsUpdates props={{}} />, {
    Title: "Установка обновлений",
    style: { height: `${400}px`, width: `${620}px`, minHeight: `${400}px`, minWidth: `${620}px` },
    hiddenButton: true,
  });
};

const openAboutSite = () => {
  smetaModals.open(<DialogAboutSite />, {
    Title: "О сайте",
    style: { height: `${530}px`, width: `${530}px` },
    Buttons: {
      jsonData: { Кнопка$Отмена: "Закрыть" },
      Params: { Buttons: 2 },
    },
    blockMaximize: true,
    blockSaveLocation: true,
    blockResize: true,
  });
};

export const openHelpContextDialog = () => {
  const helpContext = smetaStore.get(helpContextAtom);
  if (CheckModalBackGrounds() === 0 && helpContext) {
    const config = smetaStore.get(appConfig);
    if (config.smeta.openHelpContextInNewTab) {
      window.open(helpContext);
    } else {
      smetaModals.open(<DialogHelpContext />, {
        Title: "Справка",
        style: { height: `${500}px`, width: `${620}px` },
        hiddenButton: true,
        blockMaximize: true,
      });
    }
  }
};

const openSupportRequest = () => {
  smetaModals.open(<SupportRequest />, {
    Title: "Заявка в службу поддержки",
    style: {
      height: "690px",
      width: "850px",
      minHeight: "750px",
      minWidth: "950px",
      overflow: "hidden",
    },
    hiddenButton: true,
    blockSaveLocation: true,
    disableBlockBackground: true,
    blockCollapse: true,
  });
};

const SupportButton: FC = () => {
  const theme = useAtomValue(currentTheme);
  // const isDev: boolean = isDeveloper();
  const isLk = getOptionsForUser()?.from;
  const helpContext = useAtomValue(helpContextAtom);

  if (isLk === "lk") return null;
  return (
    <IconMenuButton
      title="Справка"
      items={[
        {
          label: "Вызов справки",
          onClick: openHelpContextDialog,
          icon: <QuizIcon className={clsx("iconButtonStimate", { light: theme === "light" })} />,
          shortCut: "F1",
          hidden: !helpContext,
        },
        { label: "Заявка в службу поддержки", onClick: openSupportRequest },
        { label: "divider" },
        { label: "Проверить наличие обновлений", onClick: openUpdtInstall },
        { label: "Файл с ошибками", onClick: downloadErrorFile },
        { label: "О сайте...", onClick: openAboutSite },
      ]}
    >
      <HelpIcon className={clsx("iconButtonStimate", { light: theme === "light" })} />
    </IconMenuButton>
  );
};

export default SupportButton;
